import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BoardStages } from 'app/trello/models/board-stages';
import { RequestErrorThrower } from 'app/trello/services/request-error-thrower';
import { TokenService } from 'app/trello/services/token.service';
import { environment } from 'environments/environment';
import { catchError, Observable, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BoardStagesSender {

  constructor(
    private readonly http: HttpClient,
    private readonly requestErrorThrower: RequestErrorThrower,
    private readonly tokenService: TokenService,
  ) {
  }

  public send(
    boardStages: BoardStages,
  ): Observable<void> {

    const url = `${environment.apiRoot}${environment.endpoints.boardStages}`;

    return this.tokenService.userToken
      .pipe(
        take(1),
        switchMap((userToken) =>

          this.http.put<void>(
            url,
            boardStages,
            {headers: {Authorization: `Bearer ${userToken}`}},
          ),
        ),
        catchError((error: any) => {

          console.error('An error occurred sending board stages:', error);

          return this.requestErrorThrower.throwError(error);
        }),
      );
  }

}
